import { InjectionToken } from "@angular/core";

export interface IStatePropMap {
    [stateProp: string]: {
        getList?: string | RegExp,
        getDetail?: string | RegExp,
        mutate?: string | RegExp,
        delete?: string | RegExp,
        getUserPermission?: string | RegExp,
    };
}

export const StateToMapConfig = new InjectionToken<IStatePropMap>("StateToMapConfig");
